(function () {

  /* INIT FUNCTION */
  function initCartRelated() {
    const wrapper = document.querySelector('[data-cart-related]');
    if (!wrapper) return;

    const productId = wrapper.dataset.productId;
    const productHandle = wrapper.dataset.productHandle;

    if (!productId || !productHandle) return;

    // Try Shopify related products first
    fetch(`/recommendations/products.json?product_id=${productId}&limit=8&intent=related`)
      .then(r => r.json())
      .then(data => {
        if (data.products && data.products.length) {
          renderProducts(data.products, wrapper);
        } else {
          fetchCollectionFallback(productHandle, wrapper);
        }
      })
      .catch(() => {
        fetchCollectionFallback(productHandle, wrapper);
      });
  }

  /* FALLBACK → SAME COLLECTION */
  function fetchCollectionFallback(handle, wrapper) {
    fetch(`/products/${handle}.js`)
      .then(r => r.json())
      .then(product => {
        if (!product.collections || !product.collections.length) return;
        const colHandle = product.collections[0].handle;

        fetch(`/collections/${colHandle}/products.json?limit=8`)
          .then(r => r.json())
          .then(data => {
            if (data.products && data.products.length) {
              renderProducts(data.products, wrapper);
            }
          });
      });
  }

  /* RENDER PRODUCTS */
  function renderProducts(products, wrapper) {
    const slider = wrapper.querySelector('.cart-related__slider');
    if (!slider) return;

    slider.innerHTML = '';

    products.forEach(p => {
      slider.insertAdjacentHTML(
        'beforeend',
        `
        <div class="cart-related__item">
          <a href="/products/${p.handle}">
            <img src="${p.images[0]?.src}" alt="${p.title}">
            <p class="cart-related__title">${p.title}</p>
            <span class="cart-related__price">
              ${Shopify.formatMoney(p.variants[0].price * 100)}
            </span>
          </a>
          <button
            class="cart-related__add"
            data-variant-id="${p.variants[0].id}">
            Add
          </button>
        </div>
        `
      );
    });
  }

  /* ADD TO CART */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.cart-related__add');
    if (!btn) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: btn.dataset.variantId,
        quantity: 1
      })
    }).then(() => {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  });

  /* 🔥 IMPORTANT TRIGGERS 🔥 */

  // 1️⃣ When page loads
  document.addEventListener('DOMContentLoaded', initCartRelated);

  // 2️⃣ When cart drawer opens (Dawn & similar)
  document.addEventListener('cart:refresh', initCartRelated);

  // 3️⃣ Fallback: small delay after any click on cart icon
  document.addEventListener('click', function (e) {
    if (e.target.closest('[href="/cart"], .header__icon--cart')) {
      setTimeout(initCartRelated, 500);
    }
  });

})();